document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("magazine-masthead");
  const triggerDiv = document.querySelector(".magazine-issue__hero-banner");
  if (header && triggerDiv) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            header.classList.remove("blur");
            header.classList.add("trans");
          } else {
            header.classList.remove("trans");
            header.classList.add("blur");
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(triggerDiv);
  }
});
